// Fase 2, W13: módulo Relatórios (inadimplência, DRE, fluxo, extrato, centros, parceiros, MRR e exportações), em pt, en e es.
// Fase 2, W21 (K13): margem por serviço.
const pt = {
  nome: 'Relatórios',
  // Fase 2 (W31, 6.2): página de entrada, com a estrutura de textos do sistema antigo (título, subtítulo e um cartão por relatório).
  subtitulo: 'Análises financeiras e operacionais',
  pagina: {
    descricoes: {
      'painel-grupo': 'Como anda o grupo: os números de cada empresa lado a lado e o total geral.',
      inadimplencia: 'Títulos vencidos por faixa de dias de atraso, com os clientes que mais devem.',
      dre: 'Demonstrativo de resultado simplificado, com receitas e despesas por grupo e categoria.',
      fluxo: 'Entradas e saídas reais por período, agrupadas por dia, semana ou mês.',
      extrato: 'Entradas e saídas de contas a receber e a pagar, com o saldo acumulado.',
      centros: 'Receitas e despesas de cada centro de custo no período.',
      parceiros: 'Receitas por cliente e despesas por fornecedor, ordenadas pelo valor no período.',
      mrr: 'Receita recorrente mensal calculada a partir dos contratos ativos.',
      margem: 'Receita, custo e margem de cada serviço vendido no período.',
      quadro: 'Pessoas por departamento e função no período: ativos, afastados, admitidos e desligados.',
      folha: 'Totais da folha de cada competência: proventos, descontos, encargos, líquido e custo.',
      exportacoes: 'Arquivos de relatório gerados para baixar, com o andamento de cada um.',
    },
  },
  abas: {
    inicio: 'Todos os relatórios',
    'painel-grupo': 'Painel do grupo',
    inadimplencia: 'Inadimplência',
    dre: 'DRE',
    fluxo: 'Fluxo de caixa',
    extrato: 'Extrato consolidado',
    centros: 'Por centro de custo',
    parceiros: 'Por cliente e fornecedor',
    mrr: 'MRR',
    margem: 'Margem por serviço',
    quadro: 'Quadro de pessoas',
    folha: 'Folha por competência',
    exportacoes: 'Exportações',
  },
  comum: {
    base: { competencia: 'Competência', caixa: 'Caixa' },
    baseRotulo: 'Regime',
    escopoEmpresa: 'Empresa: {{nome}}',
    escopoConsolidado_one: 'Consolidado de {{count}} empresa',
    escopoConsolidado_other: 'Consolidado de {{count}} empresas',
    intercompany: 'Entre empresas do grupo',
    separados: 'Separados',
    eliminados: 'Eliminados',
    usarPadrao: 'Usar como padrão',
    padraoSalvo: 'Padrão do consolidado salvo',
    grupoParceiros_one: '{{count}} parceiro reconhecido como empresa do grupo pelo CNPJ',
    grupoParceiros_other: '{{count}} parceiros reconhecidos como empresa do grupo pelo CNPJ',
    exportar: 'Exportar CSV',
    exportacaoNaFila: 'Exportação na fila. Acompanhe em Exportações.',
    verExportacoes: 'Ver exportações',
    moeda: 'Moeda {{moeda}}',
    semParceiro: 'Sem parceiro',
    semCategoria: 'Sem categoria',
    semCentro: 'Sem centro',
    semNome: 'Sem nome',
    total: 'Total',
    valor: 'Valor',
    detalhar: 'Ver lançamentos de {{nome}}',
    tabela: 'Tabela do relatório',
    atualizar: 'Atualizar',
  },
  detalhe: {
    titulo: 'Lançamentos de {{nome}}',
    data: 'Data',
    descricao: 'Descrição',
    parceiro: 'Parceiro',
    categoria: 'Categoria',
    valor: 'Valor',
    origem: { lancamento: 'Lançamento', documento: 'Documento', apropriacao: 'Sem caixa' },
    componente: { principal: 'Principal', juros: 'Juros', multa: 'Multa', desconto: 'Desconto', tarifa: 'Tarifa', perda: 'Perda' },
    soma: 'Soma do filtro inteiro: {{valor}}',
    mostrando: 'Mostrando {{n}} de {{total}} linhas. Exporte o relatório para ver todas.',
    vazio: 'Nenhum lançamento neste número.',
    abrirLancamentos: 'Abrir em Movimentações',
    abrirDocumento: 'Abrir documento {{numero}}',
  },
  dre: {
    titulo: 'DRE em {{base}}',
    visao: 'Visão',
    retrato: 'Retrato',
    arvore: 'Árvore',
    serie: 'Série por mês',
    periodoInteiro: 'Período inteiro',
    linha: 'Linha',
    eliminacoes: 'Eliminações',
    consolidado: 'Consolidado',
    linhas: {
      receita_bruta: 'Receita bruta',
      deducoes: 'Deduções',
      receita_liquida: 'Receita líquida',
      custos: 'Custos',
      lucro_bruto: 'Lucro bruto',
      despesas_operacionais: 'Despesas operacionais',
      resultado_operacional: 'Resultado operacional',
      resultado_financeiro: 'Resultado financeiro',
      nao_operacional: 'Não operacional',
      sem_grupo: 'Sem grupo da DRE',
      sem_categoria: 'Sem categoria',
      resultado: 'Resultado',
      fora_dre: 'Fora da DRE',
    },
    foraAjuda: 'Investimento, empréstimo e distribuição: aparecem abaixo e não entram no resultado.',
    semGrupoAjuda: 'Categorias sem grupo da DRE e lançamentos sem categoria entram no resultado. Classifique em Cadastros > Financeiro > Plano de contas.',
    vazioTitulo: 'Nenhum resultado no período',
    vazioTexto: 'Quando houver documentos emitidos ou lançamentos no período, a DRE aparece aqui com a cascata completa.',
  },
  inadimplencia: {
    referencia: 'Dias contados até {{data}}, no fuso do workspace',
    faixas: { a_vencer: 'A vencer', '1_15': '1 a 15 dias', '16_30': '16 a 30 dias', '31_60': '31 a 60 dias', '61_90': '61 a 90 dias', mais_90: 'Mais de 90 dias' },
    aVencer: 'A vencer',
    vencido: 'Vencido',
    atualizado: 'Valor atualizado',
    encargos: 'Juros e multa estimados',
    percentual: 'Inadimplência',
    creditos: 'Créditos (notas de crédito)',
    porFaixa: 'Por faixa',
    porCliente: 'Por cliente',
    cliente: 'Cliente',
    documentos: 'Títulos',
    principal: 'Principal',
    juros: 'Juros',
    multa: 'Multa',
    liquido: 'Líquido',
    maisAntigo: 'Mais antigo',
    atrasoMedio: 'Atraso médio',
    dias_one: '{{count}} dia',
    dias_other: '{{count}} dias',
    titulosDe: 'Títulos de {{nome}}',
    numero: 'Número',
    vencimento: 'Vencimento',
    atraso: 'Atraso',
    vazioTitulo: 'Nada em aberto a receber',
    vazioTexto: 'Faturas em aberto ou parciais aparecem aqui por faixa de atraso, com juros e multa estimados. Títulos perdidos ficam de fora.',
    nota: 'Valor atualizado = saldo + juros e multa estimados pela mesma conta da baixa. Notas de crédito em aberto abatem o que o cliente deve.',
  },
  fluxo: {
    agrupar: 'Agrupar por',
    por: { dia: 'Dia', semana: 'Semana', mes: 'Mês' },
    visao: 'Visão',
    porPeriodo: 'Por período',
    porCategoria: 'Por categoria',
    conta: 'Conta',
    todasContas: 'Todas as contas',
    abertura: 'Saldo de abertura',
    entradasRealizadas: 'Entradas realizadas',
    saidasRealizadas: 'Saídas realizadas',
    previstoEntradas: 'A receber previsto',
    previstoSaidas: 'A pagar previsto',
    saldoFinal: 'Saldo final projetado',
    periodo: 'Período',
    saldoProjetado: 'Saldo projetado',
    intervalo: '{{de}} a {{ate}}',
    entradas: 'Entradas',
    saidas: 'Saídas',
    resultado: 'Resultado',
    avisoConta: 'Por conta, os títulos em aberto do Contas não entram no previsto (eles não têm conta).',
    avisoSemTitulos: 'Os títulos em aberto do Contas ficam de fora do previsto (sem acesso ao Contas).',
    categoriasAjuda: 'O dinheiro do período por categoria, com juros, multa, desconto e tarifa nas categorias deles. Transferências entre contas não entram.',
    vazioTitulo: 'Nenhuma movimentação no período',
    vazioTexto: 'Entradas, saídas e o previsto do Contas aparecem aqui, por moeda, com o saldo projetado.',
  },
  extrato: {
    contas: 'Contas',
    saldoAnterior: 'Saldo anterior',
    entradas: 'Entradas',
    saidas: 'Saídas',
    saldoFinal: 'Saldo final',
    data: 'Data',
    descricao: 'Descrição',
    valor: 'Valor',
    saldo: 'Saldo',
    transferenciaPara: 'Transferência para {{conta}}',
    transferenciaDe: 'Transferência de {{conta}}',
    estorno: 'Estorno',
    estornado: 'Estornado',
    conciliado: 'Conciliado',
    inativa: 'Inativa',
    tipo: { entrada: 'Entrada', saida: 'Saída', transferencia: 'Transferência' },
    totalMoeda: 'Total em {{moeda}}',
    semLinhas: 'Sem lançamentos no período.',
    truncado: 'Mostrando {{n}} de {{total}} lançamentos desta conta. Exporte para ver todos.',
    fecha: 'Cada conta fecha com o saldo do Financeiro na data final.',
    vazioTitulo: 'Nenhuma conta no escopo',
    vazioTexto: 'Cadastre as contas em Cadastros > Financeiro > Contas financeiras para ver o extrato com saldo corrido.',
  },
  centros: {
    centro: 'Centro de custo',
    colunas: {
      receita_bruta: 'Receita bruta',
      deducoes: 'Deduções',
      custos: 'Custos',
      despesas_operacionais: 'Despesas operacionais',
      resultado_financeiro: 'Financeiro',
      nao_operacional: 'Não operacional',
      outros: 'Outros',
    },
    resultado: 'Resultado',
    foraDre: 'Fora da DRE',
    outrosAjuda: '"Outros" junta categorias sem grupo da DRE e lançamentos sem categoria. O que não tem centro fica em "Sem centro" e entra no total.',
    vazioTitulo: 'Nenhum resultado no período',
    vazioTexto: 'Documentos e lançamentos com centro de custo (ou rateio) aparecem aqui por centro, com o balde "Sem centro".',
  },
  parceiros: {
    lado: 'Ver',
    clientes: 'Clientes',
    fornecedores: 'Fornecedores',
    parceiro: 'Parceiro',
    valor: 'Valor',
    participacao: 'Participação',
    acumulado: 'Acumulado',
    classe: 'Classe',
    curva: 'Curva ABC',
    classeResumo_one: 'Classe {{classe}}: {{count}} parceiro',
    classeResumo_other: 'Classe {{classe}}: {{count}} parceiros',
    ajuda: 'Clientes pela receita bruta; fornecedores por custos e despesas operacionais. A participação soma 100,00%; A até 80%, B até 95%, C o resto.',
    vazioTitulo: 'Nenhum valor no período',
    vazioTexto: 'Quando houver receita ou despesa com parceiro no período, o peso de cada um aparece aqui com a curva ABC.',
  },
  mrr: {
    tituloRecorrencias: 'MRR estimado (recorrências)',
    tituloContratos: 'MRR por contrato',
    avisoRecorrencias: 'Estimativa pelas recorrências de fatura do Contas, normalizada pela periodicidade. Troca pela versão por contrato quando o módulo de Contratos estiver instalado.',
    referencia: 'Na data {{data}}',
    mrr: 'MRR',
    arr: 'ARR',
    ativos: 'Ativos',
    pausado: 'MRR pausado',
    aIniciar: 'Contratado a iniciar',
    porPeriodicidade: 'Por periodicidade',
    porCliente: 'Por cliente',
    porEmpresa: 'Por empresa',
    periodicidade: 'Periodicidade',
    periodicidades: { mensal: 'Mensal', bimestral: 'Bimestral', trimestral: 'Trimestral', semestral: 'Semestral', anual: 'Anual', meses_one: 'A cada {{count}} mês', meses_other: 'A cada {{count}} meses', semanal: 'Semanal', diaria: 'Diária', semanas_one: 'A cada {{count}} semana', semanas_other: 'A cada {{count}} semanas', dias_one: 'A cada {{count}} dia', dias_other: 'A cada {{count}} dias' },
    cliente: 'Cliente',
    empresa: 'Empresa',
    vazioTitulo: 'Nenhuma receita recorrente',
    vazioTexto: 'Cadastre recorrências de fatura em Financeiro > Recorrências para ver o MRR estimado.',
  },
  margem: {
    titulo: 'Margem por serviço realizada',
    receita: 'Receita',
    custo: 'Custo',
    margem: 'Margem',
    margemPct: 'Margem %',
    servico: 'Serviço',
    cobrancas: 'Cobranças',
    semServico: '{{nome}} (sem serviço do catálogo)',
    porEmpresa: 'Por empresa',
    empresa: 'Empresa',
    ajuda: 'Receita líquida do desconto do contrato, das cobranças de contrato emitidas com competência no período; custo = quantidade x custo unitário do item. Clique no serviço para ver as cobranças e as faturas.',
    detalhar: 'Ver cobranças de {{nome}}',
    detalheTitulo: 'Cobranças de {{nome}}',
    competencia: 'Competência',
    contrato: 'Contrato',
    cliente: 'Cliente',
    soma: 'Soma do filtro inteiro: receita {{receita}}, custo {{custo}}, margem {{margem}}',
    mostrando: 'Mostrando {{n}} de {{total}} cobranças. Exporte o relatório para ver todas.',
    abrirFatura: 'Abrir faturas do cliente',
    detalheVazio: 'Nenhuma cobrança neste serviço.',
    vazioTitulo: 'Nenhuma cobrança de contrato no período',
    vazioTexto: 'A margem aparece quando houver contratos com serviços e custos faturados com competência no período escolhido.',
    indisponivelTitulo: 'Margem por serviço depende do módulo de Contratos',
    indisponivelTexto: 'Instale "Assinaturas e recorrência" em Admin > Módulos e cadastre os contratos com serviço e custo por item.',
  },
  exportacoes: {
    relatorio: 'Relatório',
    pedidoEm: 'Pedida em',
    estado: 'Situação',
    estados: { pendente: 'Na fila', pronto: 'Pronta', erro: 'Erro' },
    linhas: 'Linhas',
    baixar: 'Baixar',
    mascarada: 'Mascarada',
    agendada: 'Agendada',
    nomes: { inadimplencia: 'Inadimplência', dre: 'DRE', fluxo: 'Fluxo de caixa', extrato: 'Extrato consolidado', centros: 'Por centro de custo', parceiros: 'Por cliente e fornecedor', mrr: 'MRR', margem: 'Margem por serviço', quadro: 'Quadro de pessoas', folha: 'Folha por competência', painel_grupo: 'Painel do grupo' },
    ajuda: 'Cada relatório exporta o CSV completo (sem o limite da tela), gerado em segundo plano. Só você vê e baixa as suas exportações.',
    vazioTitulo: 'Nenhuma exportação ainda',
    vazioTexto: 'Use "Exportar CSV" em qualquer relatório. O arquivo fica pronto aqui.',
  },
  salvos: {
    salvar: 'Salvar',
    editar: 'Editar relatório salvo',
    salvo: 'Relatório salvo em Meus relatórios',
    nome: 'Nome',
    descricao: 'Descrição',
    periodo: 'Período ao abrir',
    periodoAjuda: 'Com um período relativo, o relatório não envelhece: abre sempre com as datas de hoje.',
    periodos: { fixo: 'As datas escolhidas', mes_atual: 'Mês atual', mes_passado: 'Mês passado', ultimos_30: 'Últimos 30 dias', trimestre_atual: 'Trimestre atual', ano_atual: 'Ano atual' },
    compartilhar: 'Compartilhar com',
    compartilharAjuda: 'Quem abre vê só o que as próprias permissões e empresas permitem.',
    compartilhamentos: { privado: 'Só eu', papeis: 'Papéis', pessoas: 'Pessoas', workspace: 'Todo o workspace' },
    papeis: 'Papéis',
    pessoas: 'Pessoas',
    agendar: 'Agendar envio por e-mail',
    agendarTitulo: 'Envio por e-mail: {{nome}}',
    agendaAjuda: 'Cada destinatário recebe o CSV gerado com as permissões e a empresa dele. Quem não pode ver o relatório não recebe.',
    frequencia: 'Frequência',
    frequencias: { nenhuma: 'Sem envio', diaria: 'Todo dia', semanal: 'Toda semana', mensal: 'Todo mês' },
    diaSemana: 'Dia da semana',
    dias: { 0: 'Domingo', 1: 'Segunda-feira', 2: 'Terça-feira', 3: 'Quarta-feira', 4: 'Quinta-feira', 5: 'Sexta-feira', 6: 'Sábado' },
    diaMes: 'Dia do mês',
    hora: 'Hora',
    destinatarios: 'Destinatários',
    mascarar: 'Sair mascarado',
    mascararAjuda: 'Valores, percentuais e documentos saem como ***; contagens, datas e nomes ficam.',
    agendado: 'Envio agendado',
    desagendado: 'Envio cancelado',
    excluir: 'Excluir relatório salvo',
    excluirTexto: 'Excluir "{{nome}}"? Ele some também para quem o recebeu compartilhado, e o envio por e-mail para.',
    de: 'De {{nome}}',
    secoes: { meus: 'Meus relatórios', compartilhados: 'Compartilhados comigo' },
    maisCompartilhados: 'Mostrando os primeiros {{n}} compartilhados com você, em ordem alfabética.',
  },
  // E1 (R37-SPEC-M2): as visões salvas das listas marcadas "Mostrar em Relatórios".
  visoes: { secao: 'Visões das listas', selo: 'Visão de lista' },
  grupo: {
    indicador: 'Indicador',
    tabela: 'Painel do grupo por empresa',
    referencia: 'Receita, despesa e resultado realizados no caixa de {{de}} a {{ate}}. Saldo das contas em {{saldo}}; a receber e a pagar na posição de hoje.',
    ajudaEliminados: 'As operações entre empresas do grupo saem do total na coluna Eliminações.',
    ajudaSeparados: 'O total inclui as operações entre empresas do grupo.',
    ocultos: 'Os indicadores de módulos que você não acessa não aparecem.',
    vazioTitulo: 'Nenhuma empresa ativa',
    vazioTexto: 'As empresas ativas do workspace aparecem aqui, uma por coluna.',
    indicadores: {
      receita_realizada: 'Receita realizada',
      despesa_realizada: 'Despesa realizada',
      resultado: 'Resultado',
      receber_aberto: 'A receber em aberto',
      receber_vencido: 'A receber vencido',
      pagar_aberto: 'A pagar em aberto',
      pagar_vencido: 'A pagar vencido',
      saldo_contas: 'Saldo das contas',
      mrr: 'MRR',
      contratos_ativos: 'Contratos ativos',
      funcionarios_ativos: 'Funcionários ativos',
    },
  },
  quadro: {
    departamento: 'Departamento',
    funcao: 'Função',
    semDepartamento: 'Sem departamento',
    semFuncao: 'Sem função',
    colunas: { no_periodo: 'No período', ativos: 'Ativos', afastados: 'Afastados', admitidos: 'Admitidos', desligados: 'Desligados' },
    ajuda: 'Pessoas com vínculo em algum dia do período. Ativos e afastados pela situação de hoje; admitidos e desligados dentro do período.',
    vazioTitulo: 'Ninguém no período',
    vazioTexto: 'Nenhuma pessoa com vínculo nas datas escolhidas.',
  },
  folha: {
    competencia: 'Competência',
    empresa: 'Empresa',
    estado: 'Situação',
    funcionarios: 'Funcionários',
    colunas: { proventos_centavos: 'Proventos', descontos_centavos: 'Descontos', encargos_centavos: 'Encargos', liquido_centavos: 'Líquido', custo_centavos: 'Custo' },
    estados: { aberta: 'Aberta', calculada: 'Calculada', conferida: 'Conferida', fechando: 'Fechando', fechada: 'Fechada' },
    vazioTitulo: 'Nenhuma competência no período',
    vazioTexto: 'As competências abertas na Folha aparecem aqui com os totais do cálculo.',
  },
  cliente: {
    enviar: 'Enviar ao cliente',
    confirmar: 'Publicar no Portal do cliente a posição financeira de {{nome}} (títulos em aberto, em CSV)? O cliente é avisado por push e e-mail.',
    enviado_one: 'Enviado ao Portal do cliente com {{count}} título',
    enviado_other: 'Enviado ao Portal do cliente com {{count}} títulos',
  },
  portal: {
    publicar: 'Publicar no Portal',
    titulo: 'No Portal do cliente: {{nome}}',
    ajuda: 'O cliente abre sozinho, em Relatórios no Portal, sempre com os dados do momento e só com as faturas dele.',
    tipoPosicao: 'Aparece como a posição financeira do cliente (faturas em aberto e dias de atraso).',
    tipoExtrato: 'Aparece como o extrato do cliente no período (faturas, valor pago e saldo).',
    cliente: 'Cliente',
    publicarBotao: 'Publicar',
    publicado: 'Publicado no Portal do cliente',
    publicados: 'Publicado para',
    nenhum: 'Ainda não publicado para nenhum cliente.',
    publicadoEm: 'Publicado em {{data}}',
    abertoEm: 'aberto pelo cliente em {{data}}',
    nuncaAberto: 'ainda não aberto',
    despublicar: 'Despublicar',
    despublicarTexto: 'Tirar "{{titulo}}" do Portal de {{cliente}}? O cliente perde o acesso na hora.',
    despublicado: 'Retirado do Portal do cliente',
  },
};

const en: typeof pt = {
  nome: 'Reports',
  subtitulo: 'Financial and operational analyses',
  pagina: {
    descricoes: {
      'painel-grupo': 'How the group is doing: each company side by side and the grand total.',
      inadimplencia: 'Overdue bills by days past due, with the customers who owe the most.',
      dre: 'Simplified income statement, with revenue and expenses by group and category.',
      fluxo: 'Actual inflows and outflows per period, grouped by day, week or month.',
      extrato: 'Inflows and outflows from receivables and payables, with the running balance.',
      centros: 'Revenue and expenses of each cost center in the period.',
      parceiros: 'Revenue by customer and expenses by supplier, ranked by amount in the period.',
      mrr: 'Monthly recurring revenue calculated from the active contracts.',
      margem: 'Revenue, cost and margin of each service sold in the period.',
      quadro: 'People by department and role in the period: active, on leave, hired and terminated.',
      folha: 'Payroll totals of each period: earnings, deductions, charges, net and cost.',
      exportacoes: 'Report files generated for download, with the status of each one.',
    },
  },
  abas: {
    inicio: 'All reports',
    'painel-grupo': 'Group dashboard',
    inadimplencia: 'Overdue',
    dre: 'Income statement',
    fluxo: 'Cash flow',
    extrato: 'Consolidated statement',
    centros: 'By cost center',
    parceiros: 'By customer and supplier',
    mrr: 'MRR',
    margem: 'Margin by service',
    quadro: 'Headcount',
    folha: 'Payroll by period',
    exportacoes: 'Exports',
  },
  comum: {
    base: { competencia: 'Accrual', caixa: 'Cash' },
    baseRotulo: 'Basis',
    escopoEmpresa: 'Company: {{nome}}',
    escopoConsolidado_one: 'Consolidated from {{count}} company',
    escopoConsolidado_other: 'Consolidated from {{count}} companies',
    intercompany: 'Between group companies',
    separados: 'Shown',
    eliminados: 'Eliminated',
    usarPadrao: 'Use as default',
    padraoSalvo: 'Consolidation default saved',
    grupoParceiros_one: '{{count}} partner recognized as a group company by tax ID',
    grupoParceiros_other: '{{count}} partners recognized as group companies by tax ID',
    exportar: 'Export CSV',
    exportacaoNaFila: 'Export queued. Follow it in Exports.',
    verExportacoes: 'See exports',
    moeda: 'Currency {{moeda}}',
    semParceiro: 'No partner',
    semCategoria: 'No category',
    semCentro: 'No cost center',
    semNome: 'No name',
    total: 'Total',
    valor: 'Amount',
    detalhar: 'See entries of {{nome}}',
    tabela: 'Report table',
    atualizar: 'Refresh',
  },
  detalhe: {
    titulo: 'Entries of {{nome}}',
    data: 'Date',
    descricao: 'Description',
    parceiro: 'Partner',
    categoria: 'Category',
    valor: 'Amount',
    origem: { lancamento: 'Entry', documento: 'Document', apropriacao: 'No cash' },
    componente: { principal: 'Principal', juros: 'Interest', multa: 'Late fee', desconto: 'Discount', tarifa: 'Bank fee', perda: 'Write-off' },
    soma: 'Sum of the whole filter: {{valor}}',
    mostrando: 'Showing {{n}} of {{total}} lines. Export the report to see all of them.',
    vazio: 'No entries behind this number.',
    abrirLancamentos: 'Open in Transactions',
    abrirDocumento: 'Open document {{numero}}',
  },
  dre: {
    titulo: 'Income statement, {{base}} basis',
    visao: 'View',
    retrato: 'Summary',
    arvore: 'Tree',
    serie: 'Monthly series',
    periodoInteiro: 'Whole period',
    linha: 'Line',
    eliminacoes: 'Eliminations',
    consolidado: 'Consolidated',
    linhas: {
      receita_bruta: 'Gross revenue',
      deducoes: 'Deductions',
      receita_liquida: 'Net revenue',
      custos: 'Costs',
      lucro_bruto: 'Gross profit',
      despesas_operacionais: 'Operating expenses',
      resultado_operacional: 'Operating result',
      resultado_financeiro: 'Financial result',
      nao_operacional: 'Non-operating',
      sem_grupo: 'No income statement group',
      sem_categoria: 'No category',
      resultado: 'Net result',
      fora_dre: 'Outside the income statement',
    },
    foraAjuda: 'Investments, loans and distributions: shown below and not part of the result.',
    semGrupoAjuda: 'Categories without an income statement group and entries without a category are part of the result. Classify them in Records > Finance > Chart of accounts.',
    vazioTitulo: 'No result in the period',
    vazioTexto: 'When there are documents issued or entries in the period, the income statement shows here with all its lines.',
  },
  inadimplencia: {
    referencia: 'Days counted up to {{data}}, in the workspace time zone',
    faixas: { a_vencer: 'Not yet due', '1_15': '1 to 15 days', '16_30': '16 to 30 days', '31_60': '31 to 60 days', '61_90': '61 to 90 days', mais_90: 'Over 90 days' },
    aVencer: 'Not yet due',
    vencido: 'Overdue',
    atualizado: 'Updated amount',
    encargos: 'Estimated interest and fee',
    percentual: 'Overdue rate',
    creditos: 'Credits (credit notes)',
    porFaixa: 'By aging bucket',
    porCliente: 'By customer',
    cliente: 'Customer',
    documentos: 'Invoices',
    principal: 'Principal',
    juros: 'Interest',
    multa: 'Late fee',
    liquido: 'Net',
    maisAntigo: 'Oldest',
    atrasoMedio: 'Average delay',
    dias_one: '{{count}} day',
    dias_other: '{{count}} days',
    titulosDe: 'Invoices of {{nome}}',
    numero: 'Number',
    vencimento: 'Due date',
    atraso: 'Delay',
    vazioTitulo: 'Nothing open to receive',
    vazioTexto: 'Open or partially paid invoices show here by aging bucket, with estimated interest and fee. Written-off invoices are left out.',
    nota: 'Updated amount = balance + interest and fee estimated with the same calculation as the payment. Open credit notes reduce what the customer owes.',
  },
  fluxo: {
    agrupar: 'Group by',
    por: { dia: 'Day', semana: 'Week', mes: 'Month' },
    visao: 'View',
    porPeriodo: 'By period',
    porCategoria: 'By category',
    conta: 'Account',
    todasContas: 'All accounts',
    abertura: 'Opening balance',
    entradasRealizadas: 'Actual inflows',
    saidasRealizadas: 'Actual outflows',
    previstoEntradas: 'Expected receivables',
    previstoSaidas: 'Expected payables',
    saldoFinal: 'Projected closing balance',
    periodo: 'Period',
    saldoProjetado: 'Projected balance',
    intervalo: '{{de}} to {{ate}}',
    entradas: 'Inflows',
    saidas: 'Outflows',
    resultado: 'Result',
    avisoConta: 'For one account, open invoices from Receivables and payables are left out of the forecast (they have no account).',
    avisoSemTitulos: 'Open invoices from Receivables and payables are left out of the forecast (no access to that module).',
    categoriasAjuda: 'The money of the period by category, with interest, late fee, discount and bank fee in their own categories. Transfers between accounts are left out.',
    vazioTitulo: 'No movement in the period',
    vazioTexto: 'Inflows, outflows and the forecast from Receivables and payables show here, by currency, with the projected balance.',
  },
  extrato: {
    contas: 'Accounts',
    saldoAnterior: 'Previous balance',
    entradas: 'Inflows',
    saidas: 'Outflows',
    saldoFinal: 'Closing balance',
    data: 'Date',
    descricao: 'Description',
    valor: 'Amount',
    saldo: 'Balance',
    transferenciaPara: 'Transfer to {{conta}}',
    transferenciaDe: 'Transfer from {{conta}}',
    estorno: 'Reversal',
    estornado: 'Reversed',
    conciliado: 'Reconciled',
    inativa: 'Inactive',
    tipo: { entrada: 'Inflow', saida: 'Outflow', transferencia: 'Transfer' },
    totalMoeda: 'Total in {{moeda}}',
    semLinhas: 'No entries in the period.',
    truncado: 'Showing {{n}} of {{total}} entries of this account. Export to see all of them.',
    fecha: 'Each account closes with the Finance balance on the end date.',
    vazioTitulo: 'No accounts in scope',
    vazioTexto: 'Register the accounts in Records > Finance > Financial accounts to see the statement with running balance.',
  },
  centros: {
    centro: 'Cost center',
    colunas: {
      receita_bruta: 'Gross revenue',
      deducoes: 'Deductions',
      custos: 'Costs',
      despesas_operacionais: 'Operating expenses',
      resultado_financeiro: 'Financial',
      nao_operacional: 'Non-operating',
      outros: 'Other',
    },
    resultado: 'Result',
    foraDre: 'Outside the income statement',
    outrosAjuda: '"Other" groups categories without an income statement group and entries without a category. What has no cost center goes to "No cost center" and is part of the total.',
    vazioTitulo: 'No result in the period',
    vazioTexto: 'Documents and entries with a cost center (or split) show here by center, with the "No cost center" bucket.',
  },
  parceiros: {
    lado: 'Show',
    clientes: 'Customers',
    fornecedores: 'Suppliers',
    parceiro: 'Partner',
    valor: 'Amount',
    participacao: 'Share',
    acumulado: 'Cumulative',
    classe: 'Class',
    curva: 'ABC curve',
    classeResumo_one: 'Class {{classe}}: {{count}} partner',
    classeResumo_other: 'Class {{classe}}: {{count}} partners',
    ajuda: 'Customers by gross revenue; suppliers by costs and operating expenses. Shares add up to 100.00%; A up to 80%, B up to 95%, C the rest.',
    vazioTitulo: 'No amounts in the period',
    vazioTexto: 'When there is revenue or expense with a partner in the period, the weight of each one shows here with the ABC curve.',
  },
  mrr: {
    tituloRecorrencias: 'Estimated MRR (recurring invoices)',
    tituloContratos: 'MRR by contract',
    avisoRecorrencias: 'Estimate from the recurring invoices of Receivables and payables, normalized by frequency. It switches to the contract version when the Contracts module is installed.',
    referencia: 'On {{data}}',
    mrr: 'MRR',
    arr: 'ARR',
    ativos: 'Active',
    pausado: 'Paused MRR',
    aIniciar: 'Signed, not started',
    porPeriodicidade: 'By frequency',
    porCliente: 'By customer',
    porEmpresa: 'By company',
    periodicidade: 'Frequency',
    periodicidades: { mensal: 'Monthly', bimestral: 'Bimonthly', trimestral: 'Quarterly', semestral: 'Semiannual', anual: 'Yearly', meses_one: 'Every {{count}} month', meses_other: 'Every {{count}} months', semanal: 'Weekly', diaria: 'Daily', semanas_one: 'Every {{count}} week', semanas_other: 'Every {{count}} weeks', dias_one: 'Every {{count}} day', dias_other: 'Every {{count}} days' },
    cliente: 'Customer',
    empresa: 'Company',
    vazioTitulo: 'No recurring revenue',
    vazioTexto: 'Register recurring invoices in Finance > Recurring to see the estimated MRR.',
  },
  margem: {
    titulo: 'Realized margin by service',
    receita: 'Revenue',
    custo: 'Cost',
    margem: 'Margin',
    margemPct: 'Margin %',
    servico: 'Service',
    cobrancas: 'Charges',
    semServico: '{{nome}} (no catalog service)',
    porEmpresa: 'By company',
    empresa: 'Company',
    ajuda: 'Revenue net of the contract discount, from contract charges issued with accrual month in the period; cost = quantity x item unit cost. Click a service to see its charges and invoices.',
    detalhar: 'See charges of {{nome}}',
    detalheTitulo: 'Charges of {{nome}}',
    competencia: 'Accrual month',
    contrato: 'Contract',
    cliente: 'Customer',
    soma: 'Sum of the whole filter: revenue {{receita}}, cost {{custo}}, margin {{margem}}',
    mostrando: 'Showing {{n}} of {{total}} charges. Export the report to see all of them.',
    abrirFatura: "Open the customer's invoices",
    detalheVazio: 'No charges for this service.',
    vazioTitulo: 'No contract charges in the period',
    vazioTexto: 'The margin shows up when there are contracts with services and costs billed with accrual month in the chosen period.',
    indisponivelTitulo: 'Margin by service needs the Contracts module',
    indisponivelTexto: 'Install "Subscriptions and recurrence" in Admin > Modules and register the contracts with a service and cost per item.',
  },
  exportacoes: {
    relatorio: 'Report',
    pedidoEm: 'Requested at',
    estado: 'Status',
    estados: { pendente: 'Queued', pronto: 'Ready', erro: 'Error' },
    linhas: 'Lines',
    baixar: 'Download',
    mascarada: 'Masked',
    agendada: 'Scheduled',
    nomes: { inadimplencia: 'Overdue', dre: 'Income statement', fluxo: 'Cash flow', extrato: 'Consolidated statement', centros: 'By cost center', parceiros: 'By customer and supplier', mrr: 'MRR', margem: 'Margin by service', quadro: 'Headcount', folha: 'Payroll by period', painel_grupo: 'Group dashboard' },
    ajuda: 'Each report exports the full CSV (without the screen limit), generated in the background. Only you see and download your exports.',
    vazioTitulo: 'No exports yet',
    vazioTexto: 'Use "Export CSV" in any report. The file gets ready here.',
  },
  salvos: {
    salvar: 'Save',
    editar: 'Edit saved report',
    salvo: 'Report saved in My reports',
    nome: 'Name',
    descricao: 'Description',
    periodo: 'Period when opening',
    periodoAjuda: 'With a relative period the report never gets old: it always opens with today\'s dates.',
    periodos: { fixo: 'The chosen dates', mes_atual: 'Current month', mes_passado: 'Last month', ultimos_30: 'Last 30 days', trimestre_atual: 'Current quarter', ano_atual: 'Current year' },
    compartilhar: 'Share with',
    compartilharAjuda: 'Whoever opens it sees only what their own permissions and companies allow.',
    compartilhamentos: { privado: 'Only me', papeis: 'Roles', pessoas: 'People', workspace: 'The whole workspace' },
    papeis: 'Roles',
    pessoas: 'People',
    agendar: 'Schedule e-mail delivery',
    agendarTitulo: 'E-mail delivery: {{nome}}',
    agendaAjuda: 'Each recipient gets the CSV generated with their own permissions and company. Whoever cannot see the report gets nothing.',
    frequencia: 'Frequency',
    frequencias: { nenhuma: 'No delivery', diaria: 'Every day', semanal: 'Every week', mensal: 'Every month' },
    diaSemana: 'Day of the week',
    dias: { 0: 'Sunday', 1: 'Monday', 2: 'Tuesday', 3: 'Wednesday', 4: 'Thursday', 5: 'Friday', 6: 'Saturday' },
    diaMes: 'Day of the month',
    hora: 'Time',
    destinatarios: 'Recipients',
    mascarar: 'Masked output',
    mascararAjuda: 'Amounts, percentages and documents come out as ***; counts, dates and names stay.',
    agendado: 'Delivery scheduled',
    desagendado: 'Delivery canceled',
    excluir: 'Delete saved report',
    excluirTexto: 'Delete "{{nome}}"? It also disappears for whoever received it shared, and the e-mail delivery stops.',
    de: 'From {{nome}}',
    secoes: { meus: 'My reports', compartilhados: 'Shared with me' },
    maisCompartilhados: 'Showing the first {{n}} reports shared with you, in alphabetical order.',
  },
  visoes: { secao: 'List views', selo: 'List view' },
  grupo: {
    indicador: 'Indicator',
    tabela: 'Group dashboard by company',
    referencia: 'Revenue, expenses and result realized in cash from {{de}} to {{ate}}. Account balances on {{saldo}}; receivables and payables as of today.',
    ajudaEliminados: 'Transactions between group companies are removed from the total in the Eliminations column.',
    ajudaSeparados: 'The total includes transactions between group companies.',
    ocultos: 'Indicators from modules you cannot access are not shown.',
    vazioTitulo: 'No active company',
    vazioTexto: 'The active companies of the workspace show up here, one per column.',
    indicadores: {
      receita_realizada: 'Realized revenue',
      despesa_realizada: 'Realized expenses',
      resultado: 'Result',
      receber_aberto: 'Open receivables',
      receber_vencido: 'Overdue receivables',
      pagar_aberto: 'Open payables',
      pagar_vencido: 'Overdue payables',
      saldo_contas: 'Account balances',
      mrr: 'MRR',
      contratos_ativos: 'Active contracts',
      funcionarios_ativos: 'Active employees',
    },
  },
  quadro: {
    departamento: 'Department',
    funcao: 'Role',
    semDepartamento: 'No department',
    semFuncao: 'No role',
    colunas: { no_periodo: 'In the period', ativos: 'Active', afastados: 'On leave', admitidos: 'Hired', desligados: 'Terminated' },
    ajuda: 'People employed on at least one day of the period. Active and on leave by today\'s status; hired and terminated within the period.',
    vazioTitulo: 'No one in the period',
    vazioTexto: 'No person employed on the chosen dates.',
  },
  folha: {
    competencia: 'Period',
    empresa: 'Company',
    estado: 'Status',
    funcionarios: 'Employees',
    colunas: { proventos_centavos: 'Earnings', descontos_centavos: 'Deductions', encargos_centavos: 'Charges', liquido_centavos: 'Net', custo_centavos: 'Cost' },
    estados: { aberta: 'Open', calculada: 'Calculated', conferida: 'Reviewed', fechando: 'Closing', fechada: 'Closed' },
    vazioTitulo: 'No payroll period in the range',
    vazioTexto: 'Periods opened in Payroll show here with the calculation totals.',
  },
  cliente: {
    enviar: 'Send to customer',
    confirmar: 'Publish the financial position of {{nome}} (open invoices, as CSV) in the client portal? The customer is notified by push and e-mail.',
    enviado_one: 'Sent to the client portal with {{count}} invoice',
    enviado_other: 'Sent to the client portal with {{count}} invoices',
  },
  portal: {
    publicar: 'Publish on the portal',
    titulo: 'On the client portal: {{nome}}',
    ajuda: 'The customer opens it on their own, under Reports in the portal, always with current data and only their own invoices.',
    tipoPosicao: "Shows as the customer's financial position (open invoices and days late).",
    tipoExtrato: "Shows as the customer's statement for the period (invoices, amount paid and balance).",
    cliente: 'Customer',
    publicarBotao: 'Publish',
    publicado: 'Published on the client portal',
    publicados: 'Published to',
    nenhum: 'Not published to any customer yet.',
    publicadoEm: 'Published on {{data}}',
    abertoEm: 'opened by the customer on {{data}}',
    nuncaAberto: 'not opened yet',
    despublicar: 'Unpublish',
    despublicarTexto: 'Remove "{{titulo}}" from the portal of {{cliente}}? The customer loses access immediately.',
    despublicado: 'Removed from the client portal',
  },
};

const es: typeof pt = {
  nome: 'Informes',
  subtitulo: 'Análisis financieros y operativos',
  pagina: {
    descricoes: {
      'painel-grupo': 'Cómo va el grupo: los números de cada empresa lado a lado y el total general.',
      inadimplencia: 'Títulos vencidos por rango de días de atraso, con los clientes que más deben.',
      dre: 'Estado de resultados simplificado, con ingresos y gastos por grupo y categoría.',
      fluxo: 'Entradas y salidas reales por período, agrupadas por día, semana o mes.',
      extrato: 'Entradas y salidas de cuentas por cobrar y por pagar, con el saldo acumulado.',
      centros: 'Ingresos y gastos de cada centro de costo en el período.',
      parceiros: 'Ingresos por cliente y gastos por proveedor, ordenados por valor en el período.',
      mrr: 'Ingreso recurrente mensual calculado a partir de los contratos activos.',
      margem: 'Ingreso, costo y margen de cada servicio vendido en el período.',
      quadro: 'Personas por departamento y función en el período: activos, con licencia, admitidos y desvinculados.',
      folha: 'Totales de la nómina de cada período: haberes, descuentos, cargas, neto y costo.',
      exportacoes: 'Archivos de informe generados para descargar, con el avance de cada uno.',
    },
  },
  abas: {
    inicio: 'Todos los informes',
    'painel-grupo': 'Panel del grupo',
    inadimplencia: 'Morosidad',
    dre: 'Estado de resultados',
    fluxo: 'Flujo de caja',
    extrato: 'Extracto consolidado',
    centros: 'Por centro de costo',
    parceiros: 'Por cliente y proveedor',
    mrr: 'MRR',
    margem: 'Margen por servicio',
    quadro: 'Plantilla de personal',
    folha: 'Nómina por período',
    exportacoes: 'Exportaciones',
  },
  comum: {
    base: { competencia: 'Devengado', caixa: 'Caja' },
    baseRotulo: 'Criterio',
    escopoEmpresa: 'Empresa: {{nome}}',
    escopoConsolidado_one: 'Consolidado de {{count}} empresa',
    escopoConsolidado_other: 'Consolidado de {{count}} empresas',
    intercompany: 'Entre empresas del grupo',
    separados: 'Separados',
    eliminados: 'Eliminados',
    usarPadrao: 'Usar como predeterminado',
    padraoSalvo: 'Predeterminado del consolidado guardado',
    grupoParceiros_one: '{{count}} socio reconocido como empresa del grupo por el CNPJ',
    grupoParceiros_other: '{{count}} socios reconocidos como empresas del grupo por el CNPJ',
    exportar: 'Exportar CSV',
    exportacaoNaFila: 'Exportación en cola. Síguela en Exportaciones.',
    verExportacoes: 'Ver exportaciones',
    moeda: 'Moneda {{moeda}}',
    semParceiro: 'Sin socio',
    semCategoria: 'Sin categoría',
    semCentro: 'Sin centro',
    semNome: 'Sin nombre',
    total: 'Total',
    valor: 'Valor',
    detalhar: 'Ver asientos de {{nome}}',
    tabela: 'Tabla del informe',
    atualizar: 'Actualizar',
  },
  detalhe: {
    titulo: 'Asientos de {{nome}}',
    data: 'Fecha',
    descricao: 'Descripción',
    parceiro: 'Socio',
    categoria: 'Categoría',
    valor: 'Valor',
    origem: { lancamento: 'Asiento', documento: 'Documento', apropriacao: 'Sin caja' },
    componente: { principal: 'Principal', juros: 'Intereses', multa: 'Multa', desconto: 'Descuento', tarifa: 'Comisión', perda: 'Pérdida' },
    soma: 'Suma de todo el filtro: {{valor}}',
    mostrando: 'Mostrando {{n}} de {{total}} líneas. Exporta el informe para verlas todas.',
    vazio: 'Ningún asiento en este número.',
    abrirLancamentos: 'Abrir en Movimientos',
    abrirDocumento: 'Abrir documento {{numero}}',
  },
  dre: {
    titulo: 'Estado de resultados por {{base}}',
    visao: 'Vista',
    retrato: 'Resumen',
    arvore: 'Árbol',
    serie: 'Serie mensual',
    periodoInteiro: 'Período completo',
    linha: 'Línea',
    eliminacoes: 'Eliminaciones',
    consolidado: 'Consolidado',
    linhas: {
      receita_bruta: 'Ingresos brutos',
      deducoes: 'Deducciones',
      receita_liquida: 'Ingresos netos',
      custos: 'Costos',
      lucro_bruto: 'Utilidad bruta',
      despesas_operacionais: 'Gastos operativos',
      resultado_operacional: 'Resultado operativo',
      resultado_financeiro: 'Resultado financiero',
      nao_operacional: 'No operativo',
      sem_grupo: 'Sin grupo del estado de resultados',
      sem_categoria: 'Sin categoría',
      resultado: 'Resultado',
      fora_dre: 'Fuera del estado de resultados',
    },
    foraAjuda: 'Inversión, préstamo y distribución: aparecen abajo y no entran en el resultado.',
    semGrupoAjuda: 'Las categorías sin grupo y los asientos sin categoría entran en el resultado. Clasifícalos en Registros > Finanzas > Plan de cuentas.',
    vazioTitulo: 'Ningún resultado en el período',
    vazioTexto: 'Cuando haya documentos emitidos o asientos en el período, el estado de resultados aparece aquí con todas sus líneas.',
  },
  inadimplencia: {
    referencia: 'Días contados hasta el {{data}}, en el huso horario del espacio de trabajo',
    faixas: { a_vencer: 'Por vencer', '1_15': '1 a 15 días', '16_30': '16 a 30 días', '31_60': '31 a 60 días', '61_90': '61 a 90 días', mais_90: 'Más de 90 días' },
    aVencer: 'Por vencer',
    vencido: 'Vencido',
    atualizado: 'Valor actualizado',
    encargos: 'Intereses y multa estimados',
    percentual: 'Morosidad',
    creditos: 'Créditos (notas de crédito)',
    porFaixa: 'Por tramo',
    porCliente: 'Por cliente',
    cliente: 'Cliente',
    documentos: 'Títulos',
    principal: 'Principal',
    juros: 'Intereses',
    multa: 'Multa',
    liquido: 'Neto',
    maisAntigo: 'Más antiguo',
    atrasoMedio: 'Atraso medio',
    dias_one: '{{count}} día',
    dias_other: '{{count}} días',
    titulosDe: 'Títulos de {{nome}}',
    numero: 'Número',
    vencimento: 'Vencimiento',
    atraso: 'Atraso',
    vazioTitulo: 'Nada pendiente por cobrar',
    vazioTexto: 'Las facturas abiertas o parciales aparecen aquí por tramo de atraso, con intereses y multa estimados. Las perdidas quedan fuera.',
    nota: 'Valor actualizado = saldo + intereses y multa estimados con el mismo cálculo del cobro. Las notas de crédito abiertas reducen lo que debe el cliente.',
  },
  fluxo: {
    agrupar: 'Agrupar por',
    por: { dia: 'Día', semana: 'Semana', mes: 'Mes' },
    visao: 'Vista',
    porPeriodo: 'Por período',
    porCategoria: 'Por categoría',
    conta: 'Cuenta',
    todasContas: 'Todas las cuentas',
    abertura: 'Saldo de apertura',
    entradasRealizadas: 'Ingresos realizados',
    saidasRealizadas: 'Egresos realizados',
    previstoEntradas: 'Por cobrar previsto',
    previstoSaidas: 'Por pagar previsto',
    saldoFinal: 'Saldo final proyectado',
    periodo: 'Período',
    saldoProjetado: 'Saldo proyectado',
    intervalo: '{{de}} a {{ate}}',
    entradas: 'Ingresos',
    saidas: 'Egresos',
    resultado: 'Resultado',
    avisoConta: 'Por cuenta, los títulos abiertos de Cuentas por cobrar y pagar no entran en el previsto (no tienen cuenta).',
    avisoSemTitulos: 'Los títulos abiertos de Cuentas por cobrar y pagar quedan fuera del previsto (sin acceso a ese módulo).',
    categoriasAjuda: 'El dinero del período por categoría, con intereses, multa, descuento y comisión en sus categorías. Las transferencias entre cuentas no entran.',
    vazioTitulo: 'Ningún movimiento en el período',
    vazioTexto: 'Los ingresos, egresos y el previsto de Cuentas por cobrar y pagar aparecen aquí, por moneda, con el saldo proyectado.',
  },
  extrato: {
    contas: 'Cuentas',
    saldoAnterior: 'Saldo anterior',
    entradas: 'Ingresos',
    saidas: 'Egresos',
    saldoFinal: 'Saldo final',
    data: 'Fecha',
    descricao: 'Descripción',
    valor: 'Valor',
    saldo: 'Saldo',
    transferenciaPara: 'Transferencia a {{conta}}',
    transferenciaDe: 'Transferencia de {{conta}}',
    estorno: 'Reversión',
    estornado: 'Revertido',
    conciliado: 'Conciliado',
    inativa: 'Inactiva',
    tipo: { entrada: 'Ingreso', saida: 'Egreso', transferencia: 'Transferencia' },
    totalMoeda: 'Total en {{moeda}}',
    semLinhas: 'Sin asientos en el período.',
    truncado: 'Mostrando {{n}} de {{total}} asientos de esta cuenta. Exporta para verlos todos.',
    fecha: 'Cada cuenta cierra con el saldo de Finanzas en la fecha final.',
    vazioTitulo: 'Ninguna cuenta en el alcance',
    vazioTexto: 'Registra las cuentas en Registros > Finanzas > Cuentas financieras para ver el extracto con saldo corrido.',
  },
  centros: {
    centro: 'Centro de costo',
    colunas: {
      receita_bruta: 'Ingresos brutos',
      deducoes: 'Deducciones',
      custos: 'Costos',
      despesas_operacionais: 'Gastos operativos',
      resultado_financeiro: 'Financiero',
      nao_operacional: 'No operativo',
      outros: 'Otros',
    },
    resultado: 'Resultado',
    foraDre: 'Fuera del estado de resultados',
    outrosAjuda: '"Otros" junta categorías sin grupo y asientos sin categoría. Lo que no tiene centro queda en "Sin centro" y entra en el total.',
    vazioTitulo: 'Ningún resultado en el período',
    vazioTexto: 'Los documentos y asientos con centro de costo (o prorrateo) aparecen aquí por centro, con el grupo "Sin centro".',
  },
  parceiros: {
    lado: 'Ver',
    clientes: 'Clientes',
    fornecedores: 'Proveedores',
    parceiro: 'Socio',
    valor: 'Valor',
    participacao: 'Participación',
    acumulado: 'Acumulado',
    classe: 'Clase',
    curva: 'Curva ABC',
    classeResumo_one: 'Clase {{classe}}: {{count}} socio',
    classeResumo_other: 'Clase {{classe}}: {{count}} socios',
    ajuda: 'Clientes por los ingresos brutos; proveedores por costos y gastos operativos. La participación suma 100,00%; A hasta 80%, B hasta 95%, C el resto.',
    vazioTitulo: 'Ningún valor en el período',
    vazioTexto: 'Cuando haya ingresos o gastos con un socio en el período, el peso de cada uno aparece aquí con la curva ABC.',
  },
  mrr: {
    tituloRecorrencias: 'MRR estimado (recurrencias)',
    tituloContratos: 'MRR por contrato',
    avisoRecorrencias: 'Estimación por las facturas recurrentes de Cuentas por cobrar y pagar, normalizada por la periodicidad. Cambia a la versión por contrato cuando se instale el módulo de Contratos.',
    referencia: 'En la fecha {{data}}',
    mrr: 'MRR',
    arr: 'ARR',
    ativos: 'Activos',
    pausado: 'MRR en pausa',
    aIniciar: 'Contratado por iniciar',
    porPeriodicidade: 'Por periodicidad',
    porCliente: 'Por cliente',
    porEmpresa: 'Por empresa',
    periodicidade: 'Periodicidad',
    periodicidades: { mensal: 'Mensual', bimestral: 'Bimestral', trimestral: 'Trimestral', semestral: 'Semestral', anual: 'Anual', meses_one: 'Cada {{count}} mes', meses_other: 'Cada {{count}} meses', semanal: 'Semanal', diaria: 'Diaria', semanas_one: 'Cada {{count}} semana', semanas_other: 'Cada {{count}} semanas', dias_one: 'Cada {{count}} día', dias_other: 'Cada {{count}} días' },
    cliente: 'Cliente',
    empresa: 'Empresa',
    vazioTitulo: 'Ningún ingreso recurrente',
    vazioTexto: 'Registra facturas recurrentes en Finanzas > Recurrencias para ver el MRR estimado.',
  },
  margem: {
    titulo: 'Margen por servicio realizado',
    receita: 'Ingreso',
    custo: 'Costo',
    margem: 'Margen',
    margemPct: 'Margen %',
    servico: 'Servicio',
    cobrancas: 'Cobros',
    semServico: '{{nome}} (sin servicio del catálogo)',
    porEmpresa: 'Por empresa',
    empresa: 'Empresa',
    ajuda: 'Ingreso neto del descuento del contrato, de los cobros de contrato emitidos con devengo en el período; costo = cantidad x costo unitario del ítem. Haz clic en el servicio para ver los cobros y las facturas.',
    detalhar: 'Ver cobros de {{nome}}',
    detalheTitulo: 'Cobros de {{nome}}',
    competencia: 'Devengo',
    contrato: 'Contrato',
    cliente: 'Cliente',
    soma: 'Suma de todo el filtro: ingreso {{receita}}, costo {{custo}}, margen {{margem}}',
    mostrando: 'Mostrando {{n}} de {{total}} cobros. Exporta el informe para verlos todos.',
    abrirFatura: 'Abrir las facturas del cliente',
    detalheVazio: 'Ningún cobro en este servicio.',
    vazioTitulo: 'Ningún cobro de contrato en el período',
    vazioTexto: 'El margen aparece cuando hay contratos con servicios y costos facturados con devengo en el período elegido.',
    indisponivelTitulo: 'El margen por servicio depende del módulo de Contratos',
    indisponivelTexto: 'Instala "Suscripciones y recurrencia" en Admin > Módulos y registra los contratos con servicio y costo por ítem.',
  },
  exportacoes: {
    relatorio: 'Informe',
    pedidoEm: 'Pedida el',
    estado: 'Estado',
    estados: { pendente: 'En cola', pronto: 'Lista', erro: 'Error' },
    linhas: 'Líneas',
    baixar: 'Descargar',
    mascarada: 'Enmascarada',
    agendada: 'Programada',
    nomes: { inadimplencia: 'Morosidad', dre: 'Estado de resultados', fluxo: 'Flujo de caja', extrato: 'Extracto consolidado', centros: 'Por centro de costo', parceiros: 'Por cliente y proveedor', mrr: 'MRR', margem: 'Margen por servicio', quadro: 'Plantilla de personal', folha: 'Nómina por período', painel_grupo: 'Panel del grupo' },
    ajuda: 'Cada informe exporta el CSV completo (sin el límite de la pantalla), generado en segundo plano. Solo tú ves y descargas tus exportaciones.',
    vazioTitulo: 'Ninguna exportación todavía',
    vazioTexto: 'Usa "Exportar CSV" en cualquier informe. El archivo queda listo aquí.',
  },
  salvos: {
    salvar: 'Guardar',
    editar: 'Editar informe guardado',
    salvo: 'Informe guardado en Mis informes',
    nome: 'Nombre',
    descricao: 'Descripción',
    periodo: 'Período al abrir',
    periodoAjuda: 'Con un período relativo el informe no envejece: siempre abre con las fechas de hoy.',
    periodos: { fixo: 'Las fechas elegidas', mes_atual: 'Mes actual', mes_passado: 'Mes pasado', ultimos_30: 'Últimos 30 días', trimestre_atual: 'Trimestre actual', ano_atual: 'Año actual' },
    compartilhar: 'Compartir con',
    compartilharAjuda: 'Quien lo abre ve solo lo que sus propios permisos y empresas permiten.',
    compartilhamentos: { privado: 'Solo yo', papeis: 'Roles', pessoas: 'Personas', workspace: 'Todo el workspace' },
    papeis: 'Roles',
    pessoas: 'Personas',
    agendar: 'Programar envío por correo',
    agendarTitulo: 'Envío por correo: {{nome}}',
    agendaAjuda: 'Cada destinatario recibe el CSV generado con sus propios permisos y empresa. Quien no tiene permiso sobre el informe no lo recibe.',
    frequencia: 'Frecuencia',
    frequencias: { nenhuma: 'Sin envío', diaria: 'Todos los días', semanal: 'Todas las semanas', mensal: 'Todos los meses' },
    diaSemana: 'Día de la semana',
    dias: { 0: 'Domingo', 1: 'Lunes', 2: 'Martes', 3: 'Miércoles', 4: 'Jueves', 5: 'Viernes', 6: 'Sábado' },
    diaMes: 'Día del mes',
    hora: 'Hora',
    destinatarios: 'Destinatarios',
    mascarar: 'Salida enmascarada',
    mascararAjuda: 'Valores, porcentajes y documentos salen como ***; cantidades, fechas y nombres se mantienen.',
    agendado: 'Envío programado',
    desagendado: 'Envío cancelado',
    excluir: 'Eliminar informe guardado',
    excluirTexto: '¿Eliminar "{{nome}}"? También desaparece para quien lo recibió compartido, y el envío por correo se detiene.',
    de: 'De {{nome}}',
    secoes: { meus: 'Mis informes', compartilhados: 'Compartidos conmigo' },
    maisCompartilhados: 'Mostrando los primeros {{n}} informes compartidos contigo, en orden alfabético.',
  },
  visoes: { secao: 'Vistas de listas', selo: 'Vista de lista' },
  grupo: {
    indicador: 'Indicador',
    tabela: 'Panel del grupo por empresa',
    referencia: 'Ingresos, gastos y resultado realizados en caja del {{de}} al {{ate}}. Saldo de las cuentas al {{saldo}}; cuentas por cobrar y por pagar a hoy.',
    ajudaEliminados: 'Las operaciones entre empresas del grupo salen del total en la columna Eliminaciones.',
    ajudaSeparados: 'El total incluye las operaciones entre empresas del grupo.',
    ocultos: 'Los indicadores de módulos a los que no accedes no aparecen.',
    vazioTitulo: 'Ninguna empresa activa',
    vazioTexto: 'Las empresas activas del workspace aparecen aquí, una por columna.',
    indicadores: {
      receita_realizada: 'Ingresos realizados',
      despesa_realizada: 'Gastos realizados',
      resultado: 'Resultado',
      receber_aberto: 'Por cobrar abierto',
      receber_vencido: 'Por cobrar vencido',
      pagar_aberto: 'Por pagar abierto',
      pagar_vencido: 'Por pagar vencido',
      saldo_contas: 'Saldo de las cuentas',
      mrr: 'MRR',
      contratos_ativos: 'Contratos activos',
      funcionarios_ativos: 'Empleados activos',
    },
  },
  quadro: {
    departamento: 'Departamento',
    funcao: 'Función',
    semDepartamento: 'Sin departamento',
    semFuncao: 'Sin función',
    colunas: { no_periodo: 'En el período', ativos: 'Activos', afastados: 'Con licencia', admitidos: 'Admitidos', desligados: 'Desvinculados' },
    ajuda: 'Personas con vínculo algún día del período. Activos y con licencia por la situación de hoy; admitidos y desvinculados dentro del período.',
    vazioTitulo: 'Nadie en el período',
    vazioTexto: 'Ninguna persona con vínculo en las fechas elegidas.',
  },
  folha: {
    competencia: 'Período',
    empresa: 'Empresa',
    estado: 'Situación',
    funcionarios: 'Empleados',
    colunas: { proventos_centavos: 'Haberes', descontos_centavos: 'Descuentos', encargos_centavos: 'Cargas', liquido_centavos: 'Neto', custo_centavos: 'Costo' },
    estados: { aberta: 'Abierta', calculada: 'Calculada', conferida: 'Revisada', fechando: 'Cerrando', fechada: 'Cerrada' },
    vazioTitulo: 'Ningún período en el rango',
    vazioTexto: 'Los períodos abiertos en Nómina aparecen aquí con los totales del cálculo.',
  },
  cliente: {
    enviar: 'Enviar al cliente',
    confirmar: '¿Publicar en el Portal del cliente la posición financiera de {{nome}} (facturas abiertas, en CSV)? El cliente recibe aviso por push y correo.',
    enviado_one: 'Enviado al Portal del cliente con {{count}} factura',
    enviado_other: 'Enviado al Portal del cliente con {{count}} facturas',
  },
  portal: {
    publicar: 'Publicar en el Portal',
    titulo: 'En el Portal del cliente: {{nome}}',
    ajuda: 'El cliente lo abre solo, en Informes en el Portal, siempre con los datos del momento y solo con sus facturas.',
    tipoPosicao: 'Aparece como la posición financiera del cliente (facturas abiertas y días de atraso).',
    tipoExtrato: 'Aparece como el extracto del cliente en el período (facturas, valor pagado y saldo).',
    cliente: 'Cliente',
    publicarBotao: 'Publicar',
    publicado: 'Publicado en el Portal del cliente',
    publicados: 'Publicado para',
    nenhum: 'Aún no publicado para ningún cliente.',
    publicadoEm: 'Publicado el {{data}}',
    abertoEm: 'abierto por el cliente el {{data}}',
    nuncaAberto: 'aún no abierto',
    despublicar: 'Despublicar',
    despublicarTexto: '¿Quitar "{{titulo}}" del Portal de {{cliente}}? El cliente pierde el acceso al instante.',
    despublicado: 'Retirado del Portal del cliente',
  },
};

export const i18n = { pt, en, es };
